import React, { forwardRef } from 'react'

// Define ButtonProps interface
interface ButtonProps {
  label?: string;
  icon?:string;
  onClick?:any;
  className?: string; // Optional className prop
  name?:string;
  type?: 'button';
  badgeinfo?:string,
  badge?:any,
  title?:string,
  ricon?:string,
  showhide?:string,
  arialabel?:string,
  id?:string,
  isAccordionToggle?:boolean,
  btnclassName?:string
}

// ForwardRef component definition
const ActionButton = forwardRef<HTMLButtonElement, ButtonProps>(({showhide, label, onClick, className,icon,name,type,badgeinfo ,ricon,badge,arialabel,id,btnclassName}: any, ref) => (
  <button ref={ref} onClick={(e: any)=> {
    e.preventDefault()
    onClick(e)}} value={showhide} className={`btn ${className}`}  name={name} type={type || 'button'}  title={arialabel || label} aria-label={ `${ label ||['arialabel']} ${badgeinfo}`}  id={id} >
    {icon && <span className={icon}></span>} {name} {ricon && <span className={ricon}></span>} {badgeinfo && <sup className={badge}>{badgeinfo}</sup>} {<span className={btnclassName}></span>} 
  </button>
))

// Set displayName for better debugging
ActionButton.displayName = 'ActionButton'

export default ActionButton
